import React, { type PropsWithChildren } from 'react';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	container: {
		display: 'flex',
		height: '422px',
		width: '600px',
	},
});

export const FilterPopupContainer = ({ children }: PropsWithChildren) => (
	<Box xcss={styles.container}>{children}</Box>
);
